import type { GetRiskAssessmentResultAuditByIdResponseRow } from '@risksmart-app/drizzle/src/dto';
import type { GetRiskAssessmentResultAuditByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetRiskAssessmentResultAuditByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetRiskAssessmentResultAuditByIdArgs = { id: string };

export const useGetRiskAssessmentResultAuditById = createQueryHook<
  UseGetRiskAssessmentResultAuditByIdArgs,
  GetRiskAssessmentResultAuditByIdResponseRow[],
  GetRiskAssessmentResultAuditByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.auditLog.getRiskAssessmentResultAuditById.queryOptions({
      id,
    }),
  mapTrpcDataToGraphQL: (data) => ({
    risk_assessment_result_audit: data || [],
  }),
  graphqlDocument: GetRiskAssessmentResultAuditByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
